import { NgModule } from '@angular/core';

import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { RegistroActivosFijosRoutingModule } from './mostrar-info-activo-fijo-modal-routing.module';
import { RegistroActivosFijosModalComponent } from './mostrar-info-activo-fijo-modal.component';




@NgModule({
  declarations: [RegistroActivosFijosModalComponent],
  imports: [
    SharedModule,
    CommonModule,
    RegistroActivosFijosRoutingModule,
  ],
  entryComponents: []
})
export class RegistroActivosFijosModule { }
